import { Controller } from '@hotwired/stimulus';
const html2canvas = require('html2canvas');

export default class extends Controller {
  static targets = ['dashboard', 'dialog'];

  dialogTargetConnected() {
    var modal = this.dialogTarget;
    if (!modal) return;
    this.modal = modal;

    this.handleClose = this.handleClose.bind(this);
    this.modal.addEventListener('ionModalDidDismiss', this.handleClose);
  }

  dialogTargetDisconnected() {
    if (this.modal) {
      this.modal.removeEventListener('ionModalDidDismiss', this.handleClose);
    }
  }

  openDialog(event) {
    this.modal.isOpen = true;
    event.preventDefault();
  }

  dashboardScreenshotPng() {
    html2canvas(this.dashboardTarget).then((canvas) => {
      const base64img = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      a.download = 'lists-dashboard.png';
      a.href = base64img;
      a.click();
    });
  }

  dashboardScreenshotJpeg() {
    html2canvas(this.dashboardTarget).then((canvas) => {
      const base64img = canvas.toDataURL('image/jpeg');
      let a = document.createElement('a');
      a.download = 'lists-dashboard.jpg';
      a.href = base64img;
      a.click();
    });
  }

  handleClose() {
    this.modal.isOpen = false;
  }
}
